import './App.css';
import Home from './components/Home';

function App() {
  return (
    // <Dashboard />
    <Home />
  );
}

export default App;
